export const isValidateDataSource = (dataSource: any[]) => {
  return Array.isArray(dataSource) && dataSource.length > 0;
};

// export const isNormalStatus = (status: number) => {};
